import { parseBooleanEnabledSOC } from "state/abTests";

export const getGoogleOneTapLogsEnabled = parseBooleanEnabledSOC(
  "google.one.tap.logs.enabled",
  "0"
);

export const getIsCookieRetryEnabled = parseBooleanEnabledSOC(
  "web.cookie.retry.enabled",
  "0"
);
